import React, { Component } from 'react'
import PropTypes from 'prop-types'
import Parser from 'html-react-parser'
import SkyLight from 'react-skylight'
import styled, { withTheme } from 'styled-components'
import InfoBox from '../InfoBox'

const Wrapper = styled.div`
  article {
    font-size: var(--h5);
    color: var(--clr-grey-3-to-white);

    a {
      color: var(--grey-3);
      text-decoration: underline;
    }
  }
  .content-thumb {
    border: 1px solid var(--clr-text);
    border-radius: 4px;
    padding: 5px;
    max-width: 150px;
    max-height: 150px;
    margin-right: 15px;
  }
  .content-thumb:hover {
    box-shadow: 0 0 2px 1px + var(--clr-grey-3-to-white);
  }
  .skylight-dialog {
    text-align: center;
  }
  .skylight-dialog img {
    height: auto;
    max-width: 100%;
    max-height: 400px;
  }
`

class ContentFilter extends Component {
  static propTypes = {
    text: PropTypes.string.isRequired
  }

  keyboard = val => {
    document.onkeydown = e => {
      return val === 'disabled' ? false : true
    }
  }

  render() {
    const { text, name } = this.props

    return (
      <Wrapper>
        <article id="content" aria-live="assertive">
          {text &&
            Parser(text, {
              replace: domNode => {
                // early retun if dom node is not an image
                if (!domNode || !domNode.name || (domNode.name !== 'img' && domNode.name !== 'span') || !domNode.attribs.src) {
                  return
                }
                if (domNode.name && domNode.name === 'span' && domNode.attribs.class && domNode.attribs.class === 'explanation') {
                  return (
                    <InfoBox node={domNode} icon="categories/information.svg" />
                  )
                }

                // if parent dom is "a" return image without skylight
                if (domNode.parent && domNode.parent.name === 'a') {
                  return (
                    <img
                      className="content-thumb"
                      alt={name || ''}
                      src={domNode.attribs.src}
                    />
                  )
                }

                // Return skylight
                return (
                  <div>
                    <a
                      onClick={() =>
                        this.refs[`simpleDialog-${domNode.attribs.src}`].show()
                      }
                    >
                      <img
                        className="content-thumb"
                        alt={name || ''}
                        src={domNode.attribs.src}
                      />
                    </a>
                    <SkyLight
                      hideOnOverlayClicked
                      afterOpen={this.keyboard.bind(this, 'disabled')}
                      afterClose={this.keyboard.bind(this, 'enabled')}
                      role="dialog"
                      ref={`simpleDialog-${domNode.attribs.src}`}
                      dialogStyle={{
                        height: 'auto',
                        marginTop: '-250px',
                        padding: '30px'
                      }}
                    >
                      <img src={domNode.attribs.src} alt={name || ''} />
                    </SkyLight>
                  </div>
                )
              }
            })}
        </article>
      </Wrapper>
    )
  }
}

export default withTheme(ContentFilter)



// WEBPACK FOOTER //
// ./src/components/ContentFilter/ContentFilter.js